"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SegmentListSuperSegments = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(SegmentListSuperSegments, _React$PureComponent);

  function SegmentListSuperSegments() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handlePersonaClick", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(persona) {
        var selected;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selected = _this.props.selectedPersonas.find(function (value) {
                  return value.id === persona.id;
                });

                if (!selected) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return _this.props.removeSelectedPersona(persona);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return _this.props.addSelectedPersona(persona);

              case 8:
                _this.props.handleCheckBoxAction();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  var _proto = SegmentListSuperSegments.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        superSegment = _this$props.superSegment,
        key = _this$props.key,
        selectedPersonas = _this$props.selectedPersonas,
        displaySegmentIds = _this$props.displaySegmentIds;
    return /*#__PURE__*/React.createElement("li", {
      key: key,
      style: {
        backgroundColor: superSegment.color
      },
      className: "persona-list-community__title-checkbox"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
      onClick: function onClick() {
        return _this2.handlePersonaClick({
          id: parseInt(superSegment.id),
          name: superSegment.label
        });
      },
      checked: selectedPersonas.find(function (value) {
        return parseInt(value.id) === parseInt(superSegment.id);
      }) ? true : false,
      className: "persona-list-community__persona-checkbox",
      "data-canonical-name": superSegment.id + " " + superSegment.label,
      label: (displaySegmentIds ? superSegment.id : '') + " " + superSegment.label
    }));
  };

  return SegmentListSuperSegments;
}(React.PureComponent);

exports["default"] = SegmentListSuperSegments;